// Popula a seção
function populateSlide($parent, section, action = 'insert') {
  if ($parent.length > 0 && section) {
    // Atualiza a seção (Remove antes para ser criada novamente)
    if (action === 'update') {
      const $sectionUpd = $('#' + section.id);
      if ($sectionUpd.length > 0) {
        $sectionUpd.html('');
        $sectionUpd.remove();
      }
    }

    // Exibe seção
    const showSection = section['show'];
    const showSectionClass = !showSection ? 'd-none' : '';
    const containerClass = section['container-full'] == '1' ? 'container-full' : 'container';

    // Autoplay
    const autoplay = section['autoplay'] || 1;
    const autoplayMobile = section['autoplay-mobile'] || 0;
    const autoplaySpeed = section['autoplay-seconds'] || 5;

    // Itens
    let itensHTML = `<ul class="carousel carousel-inner carousel-arrows-circle slide-animation slide-fade-up slide-lista" data-autoplay="${autoplay}" data-autoplay-mobile="${autoplayMobile}" data-speed="${autoplaySpeed}"></ul>`;
    let $itens = $(itensHTML);
    if (section['lista'] && section['lista'].length > 0) {
      section['lista'].forEach((item) => {
        // Imagem
        const imgMobile = item['img_mobile'] ? item['img_mobile'] : item['img'];
        // Conteúdo
        let itemContent = '';
        if (item['show-content']) {
          itemContent = `
          <div class="img-overlay">
            <div class="container ${item['alinhamento']}">
              <div class="title slide-title">${item['titulo']}</div>
              <div class="slide-text md-text">${mdParse(item['texto'], true)}</div>
              ${
                item['btn-text']
                  ? `<div class="slide-btn"><button class="btn ${item['btn-class']} ${
                      confTheme['general'][item['btn-class'] + '-style']
                    }">${item['btn-text']}</button></div>`
                  : ''
              }
            </div>
          </div>`;
        }
        // HTML do item
        let itemHTML = `
        <li class="carousel-item">
          <a href="${item['url']}" class="slide-item">
            <img class="d-none-sm d-none-xs" src="${item['img']}" width="100%" height="700px" alt="${item['alt']}">
            <img class="d-none-xl d-none-lg d-none-md" src="${imgMobile}" width="100%" height="300px" alt="${item['alt']}">
            ${itemContent}
          </a>
        </li>`;
        const $item = $(itemHTML);
        // Estilos
        $item[0].style.setProperty('--slide-tit-color', item['tit-color']);
        $item[0].style.setProperty('--slide-txt-color', item['txt-color']);
        $item[0].style.setProperty('--slide-overlay-color', item['overlay-color']);
        $itens.append($item);
      });
    }

    // Estrutura da seção
    let sectionHTML = `
    <section id="${section['id']}" data-sec-type="slide" class="home-section slide ${showSectionClass}">
      <div class="section-content">
        <div class="${containerClass}">
          ${$itens[0].outerHTML}
        </div>
      </div>
    </section>`;

    // Cria o elemento
    let $section = $(sectionHTML);

    // Estilos
    if (Object.keys(section.styles).length > 0) {
      Object.keys(section.styles).forEach((styleVar) => {
        $section[0].style.setProperty('--' + styleVar, section.styles[styleVar]);
      });
    }

    // Ordem da seção
    $section[0].style.setProperty('--order', section['order']);
    $section[0].style.setProperty('order', section['order']);

    $parent.append($section);

    // Plugins
    setTimeout(() => {
      if (section['lista'].length > 0) {
        slideDestroySlick();
        slideInitSlick();
      }
    }, 100);
  }
}
